import { mapValues } from 'radash';
import '../tokens/border-radiuses.js';
import { colors } from '../tokens/colors.js';
import '../tokens/font-sizes.js';
import '../tokens/gaps.js';
import '../tokens/heights.js';
import '../tokens/spacings.js';
import '../tokens/widths.js';

/**
 * A mapping from fill color tones to text shadows. This ensures text remains legible on diverse
 * backgrounds by adding a subtle effect.
 */ const fillToTextShadow = {
    base: {
        none: 'none',
        soft: 'none',
        medium: 'none',
        bold: 'none'
    },
    ...mapValues(colors, ()=>({
            none: 'none',
            soft: 'none',
            medium: 'normal',
            bold: 'normal'
        }))
};

export { fillToTextShadow };
//# sourceMappingURL=fill-to-text-shadow.js.map
